import {SpaceProto} from "../space-proto"
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const"
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section"
import {getNavigationPosition} from "../../navigation/functions/get-navigation-position"
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click"
import MainMenu_CRM from "../../../../layout/menu/sections/crm/crm"
import NavigationSection from "../../navigation/navigation-section"
import {featureAccess} from "../../../gd/access-control/feature-access/feature-access"
import {Feature} from "../../../gd/access-control/feature-access/const"
import NavigationMenu_CrmContent from "../../../../layout/menu/sections/crm/menu-content";

export class SpaceCrm extends SpaceProto{

    constructor() {
        super(NavigationSectionType.CRM)

        this.title      = "CRM"
        this.svgIcon    = "isvg-crm-space"


        this.defaultPosition    = NavigationButtonPosition.MORE
    }

    onClick = () => {
        if (featureAccess(Feature.CRM)) {
            navigationStructureOnClick(this.navigation)
        } else {
            gd.modals.other.upgrade(Feature.CRM)
        }

    }

    get enabled(): boolean {
        return gd.modules.crm.enabled
    }

    get navigationStructureConfig() {
        return {
            id              : this.id,
            type            : NavigationSectionType.CRM,
            icon            : "i5-crm-account",
            name            : "CRM",
            hint            : 'CRM',
            menuComponent   : MainMenu_CRM,
            menuContent     : NavigationMenu_CrmContent,
            renderComponent : Navigation_ButtonGenericDeprecated,
            onClick         : this.onClick,
            position        : this.position, //getNavigationPosition(NavigationSectionType.CRM),
        }
    }

    get inNavigationPanel():boolean {
        if (!this.navigation) {
            return false
        }

        return this.navigation.position === NavigationButtonPosition.TOP
    }

    initNavigation() {
        if (!gd.user.isUser) return

        this.navigation         = new NavigationSection(this.navigationStructureConfig)
        this.navigation.space   = this
        gd.navigationStructure.add(this.navigation)
    }
}
